<!-- container -->
<div nz-row class="container">
  <!-- header -->
  <div nz-col nzSpan="24">
    <div nz-row nzType="flex" nzJustify="center" nzAlign="middle" class="header">
      <div id="logo-right" nz-col nzSpan="10">
        <!-- <img src="./assets/images/fm6elogowhite.png" /> -->
      </div>
      <div id="logo-left" nz-col nzSpan="10">
        <!-- <img src="./assets/images/logo.png" /> -->
      </div>
    </div>
  </div>
  <!-- section -->
  <div nz-col nzSpan="24" class="full-height">
    <div nz-row nzType="flex" nzJustify="center" nzAlign="middle" class="section">
      <div nz-col nzSpan="24">
        <h1>تم إضافة المشاركة بنجاح !</h1>
        <!-- <div class="margin-top-10">
          <button nz-button nzType="link" nzSize="large" nzShape="round" class="cancel-button">
            عرض المشاركات <i nz-icon nzType="swap-left"></i>
          </button>
        </div> -->
        <div class="margin-top-20">
          <button nz-button nzType="primary" nzSize="large" nzShape="round" class="button large" (click)="redirectToForm()">
            إضافة مشاركة جديدة <i nz-icon nzType="plus" class="icon"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
